import {
  UpdateRoleStagePermissionsRequest,
  UpdateRoleStagePermissionsResponse,
} from "./types";
import axios from "@/api/axiosInstance";

interface ApiResponse {
  data: UpdateRoleStagePermissionsResponse;
}

export const updateRoleStagePermissions = async (
  roleId: number,
  requestData: UpdateRoleStagePermissionsRequest,
): Promise<UpdateRoleStagePermissionsResponse> => {
  const response = await axios.put<ApiResponse>(
    `/api/private/business-roles/${roleId}/stage-permissions`,
    requestData,
  );
  return response.data.data;
};
